import React from "react";
import img1 from "../../../assets/img/aeroaegis_capabilities/6679.jpg";
import { MdOutlineSupportAgent, MdOutlineUpdate } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import { HiOutlineShieldCheck } from "react-icons/hi";

export default function MainSection10() {
  return (
    <section className=" pt-5 ">
      {/* <div className="container flex flex-col place-items-center mx-auto lg:flex-row">
              <div className="lg:w-1/2 xl:w-3/5 ">
                <div className="flex items-center justify-center p-4 md:p-8 lg:p-12">
                  <img
                    src={img1}
                    alt=""
                    className="rounded-lg shadow-lg  object-cover h-80 sm:min-h-96"
                  />
                </div>
              </div>
              <div className="flex flex-col px-6 py-8 space-y-6 rounded-sm sm:p-8 lg:p-12 lg:w-1/2 xl:w-2/5 bg-[#23307F] text-white">
                <h3 className="text-2xl font-bold tracki sm:text-3xl ">
                Continuous Support and Optimization
                </h3>
                <div className="flex space-x-2 sm:space-x-4 pt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="flex-shrink-0 w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <div className="space-y-2">
                    <p className="text-lg font-medium leadi">
                    Ongoing support to ensure that our products
continue to deliver value, including updates, optimizations, and technical assistance.

                    </p>
                  </div>
                </div>
              </div>
            </div> */}
      <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
        <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
          <div className="relative h-[500px] rounded-3xl overflow-hidden">
            <img
              src={img1}
              alt="Workspace with laptop and plant"
              className="object-cover w-full h-full rounded-3xl"
            />
          </div>
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
                Continuous Support and Optimization
              </h1>
              <p className="text-lg text-gray-600">
                Ongoing support to ensure product value through updates,
                optimizations, and technical assistance.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {/* Feature 1 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <MdOutlineSupportAgent className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    24/7 Technical Assistance
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Dedicated support team ensuring seamless product operation and
                  quick issue resolution.
                </p>
              </div>
              {/* Feature 2 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <MdOutlineUpdate className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Regular Updates
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Continuous updates to enhance performance and deliver new
                  features.
                </p>
              </div>
              {/* Feature 3 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <BiSupport className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Optimization Services
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Proactive monitoring and fine-tuning to ensure maximum
                  efficiency.
                </p>
              </div>
              {/* Feature 4 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <HiOutlineShieldCheck className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Enhanced Security
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Keeping products secure with the latest advancements in
                  cybersecurity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
